import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import DialogLogin from './DialogLogin';
import DialogDetail from './DialogDetail';
import EventState from './EventState';
import Utils from './Utils';

export default class Event extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // mySum: 0,
            isDialogLoginOpen: false,         
            isDialogDetailOpen: false,  
            myStop: false, // ukončení možnosti přihlašování   
            myStateData:[],    // Data pro DialogDetail   
        }
        
    // this.handleDialogLoginClose = this.handleDialogLoginClose.bind(this);
    // this.handleDialogDetailClose = this.handleDialogDetailClose.bind(this);    
    }

// Iniciální načtení dat
    componentDidMount() {
        this.getCount();
       
    }

    getCount(){
        var formData = new FormData();
        formData.append('countReservations', true);
        formData.append('EventId', this.props.myId);
        
        let fetchData = { 
          method: 'POST', body: formData,      
          headers: {
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          },  
        }
  
      // A posílám
      fetch(Utils.getURL(), fetchData)   
      .then(response => response.json())
      .then(data => {
          
          if ( data["success"]) {
            // console.log('Počet:',  data["count"]);
            // this.setState({mySum: data["count"] }) // Po přihlášení na hlavní stránku
          }
            else{
                    console.log('Neúspěch:', data["message"]);
                    // this.setState({mySum : 0 })                   
              }
      })
      .catch((error) => {
        console.error('Chyba:', error);
      });  
    } // konec getCount

    // Dialogy
    
    handleDialogLoginClose = () => {
        this.setState({isDialogLoginOpen: false});        
      };

    handleDialogDetailOpen = () => {
        this.setState({isDialogDetailOpen: true});
        this.getReservationsShort();
        
      };
    handleDialogDetailClose = () => {
        this.setState({isDialogDetailOpen: false});

      };
    
      /**
       * dá proměnnou myStop na true- důležité pokud jsem se dostal na 0 
       * a někdo byl odhlášen, pak potřeba nahodit zpět.
       */
    handleStart = () => {
        this.setState({myStop: false });
      };
    handleStop = () => {
        this.setState({myStop: true });
      };
      // Načtení pole osazenosti mše

getReservationsShort() {
  var formData = new FormData();
      formData.append('getReservationsShort', true);
      formData.append('EventId', this.props.myId);
      
      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
          // console.log('Číslo:',  data["reservation_id"]);
        // this.setState({mySum: data["reservation_id"] }); // Po přihlášení na hlavní stránku              
          
        // Načtení data.data do tabulky
        this.setState({myStateData: data.data }); // Po přihlášení na hlavní stránku              
          
        // .then(data => this.setState({movies: data}));
        }
        else{
                // console.log('Neúspěch:', data["message"]);
                // this.setState({mySum : 0 })                              
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });    
}

  
    render() {
        return (
            <div >
                {/* dialogy */}
                <DialogLogin 
                    myId = {this.props.myId} 
                    myopen={this.state.isDialogLoginOpen} 
                    onClickClose={() => this.handleDialogLoginClose()} 
                                       
                    myName = {this.props.myName} 
                    myMax = {this.props.myMax}                     
                    />
                <DialogDetail 
                    myId = {this.props.myId} 
                    myName= {this.props.myName}
                    myMax = {this.props.myMax}
                    myopen={this.state.isDialogDetailOpen}
                    myData = {this.state.myStateData}
                    onClickClose={() => this.handleDialogDetailClose()} 
                    />
                <Paper className="event">

                        
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                            <h3>{this.props.myName}</h3>
                            {this.props.myComment}                                                     
                    </Grid>
                    <Grid item xs={12}>
                        {/* <table  ><tr><td class="tablebadge"> */}
                            <EventState 
                                myMax ={this.props.myMax}  
                                myEventId = {this.props.myId}                                 
                                onStart ={() => this.handleStart()}  
                                onStop ={() => this.handleStop()}  
                            />                            
                    </Grid>
                    <Grid item xs={6}>
                        <Button  variant="contained" 
                        onClick={() => {this.handleDialogDetailOpen()} } 
                        >
                        Obsazenost</Button>                    
                        </Grid>
                        <Grid item xs={6}>

                        <Button color="primary" variant="contained" 
                        disabled = {this.state.myStop}
                        onClick={() => {this.setState({isDialogLoginOpen: true});} } 
                        >
                        Přihlásit
                        </Button>
                        </Grid>
                    
                </Grid>
                </Paper>
            </div>
        )
    }

}